var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('label',{staticClass:"label"},[_c('input',{ref:"input",staticClass:"input__input",attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder},domProps:{"value":_vm.query},on:{"input":_vm.onInput}})])])}
var staticRenderFns = []

export { render, staticRenderFns }